import styled, { createGlobalStyle } from 'styled-components';
import baseStyling from './theme/base.styled';

export const BodyStyled = createGlobalStyle`
	${baseStyling}
`;

export const SiteWrapperStyled = styled.div`
	position: relative;
	display: block;
	width: 100%;
	height: 100%;
`;
